/* eslint-disable camelcase */
import getMetaByApp from './getMetaByApp';

const mapToBASE = (view, index, parsers) => {
	const {
		getId,
		getSurveyType,
		getLongitude,
		getLattitude,
		getDateCreated,
		getGpsDistance,
	} = parsers;
	return {
		id: getId(view, index),
		type: getSurveyType(view, index),
		loc: [getLongitude(view, index), getLattitude(view, index)],
		date: getDateCreated(view, index),
		gpsdistance: getGpsDistance(view, index)
	};
};

const getMapTos = appName => {
	const { parsers } = getMetaByApp(appName);

	const { getReadingValue1, getReadingValue2, getReadingValue3, getReadingValue4, getReadingValue5, getAliasList } = parsers;

	return {
		ON_OFF: (view, index) => ({
			...mapToBASE(view, index, parsers),
			on: getReadingValue1(view, index) / 1000,
			off: getReadingValue2(view, index) / 1000
		}),

		'ON-OFF': (view, index) => ({
			...mapToBASE(view, index, parsers),
			on: getReadingValue1(view, index) / 1000,
			off: getReadingValue2(view, index) / 1000
		}),

		ON: (view, index) => ({
			...mapToBASE(view, index, parsers),
			on: getReadingValue1(view, index) / 1000
		}),

		DOC: (view, index) => {
			const item = {
				...mapToBASE(view, index, parsers),
				doc: getReadingValue1(view, index) / 100 || undefined,
			};
			return item;
		},

		REL: (view, index) => ({
			...mapToBASE(view, index, parsers),
			gRate: getReadingValue1(view, index),
			dep: getReadingValue2(view, index)
		}),

		DEPOL: (view, index) => ({
			...mapToBASE(view, index, parsers),
			on: getReadingValue1(view, index) / 1000
		}),

		NATIVE: (view, index) => ({
			...mapToBASE(view, index, parsers),
			on: getReadingValue1(view, index) / 1000
		}),

		DCVG: (view, index) => {
			const DCVG_NUM_REP_UNDEFINED = -999;
			const ir_pct = getReadingValue1(view, index) / 1000;
			return {
				...mapToBASE(view, index, parsers),
				ir_pct: ir_pct === DCVG_NUM_REP_UNDEFINED ? undefined : ir_pct
			};
		},

		ACVG: (view, index) => ({
			...mapToBASE(view, index, parsers),
			decmicrov: getReadingValue1(view, index) / 100,
			normdecmicrov: getReadingValue2(view, index) / 100,
			initialcurrent: getReadingValue3(view, index) / 100,
		}),

		ACCA: (view, index) => ({
			...mapToBASE(view, index, parsers),
			current: getReadingValue1(view, index) / 1000,
			attenuation: getReadingValue2(view, index) / 1000,
		}),

		ACPSP: (view, index) => ({
			...mapToBASE(view, index, parsers),
			ac: getReadingValue1(view, index) / 1000,
		}),

		PROFILE: (view, index) => ({
			...mapToBASE(view, index, parsers),
			elevation: getReadingValue1(view, index) / 1000,
			topelv: getReadingValue2(view, index) / 1000,
			copelv: getReadingValue3(view, index) / 1000,
			bopelv: getReadingValue4(view, index) / 1000,
			wtrelv: getReadingValue5(view, index) / 1000,
		}),

		REPORTED_ANOMALIES: (view, index) => ({
			...mapToBASE(view, index, parsers),
			aliaslist: getAliasList(view, index),
		}),
	};
};

export const getReadingMapper = (surveyType, appName) => {
	const MAP_TO = getMapTos(appName);
	return MAP_TO[surveyType] || MAP_TO.ON_OFF;
};

export default {
	getReadingMapper
};

// @note-supported-constant-needs-abstraction
